import React, { useState, useRef, useEffect, useLayoutEffect } from 'react'

import Gift from 'components/Icons/Gift'
import Flash from 'components/Icons/Flash'
import Star2 from 'components/Icons/Star2'
import BestPrice from 'components/Icons/BestPrice'
import Megaphone from 'components/Icons/Megaphone'

const tagConfig = {
  fast: {
    icon: <Flash color="white" width="0.9rem" height="0.9rem" />,
    text: 'სწრაფი მიტანა',
    background: 'linear-gradient(to right top, #d658e8, #7f00ff)',
  },
  top: {
    icon: <Star2 color="white" size="1rem" />,
    text: 'პოპულარული',
    background: 'linear-gradient(to right top, #b2de00, #40bd00)',
  },
  gift: {
    icon: <Gift color="white" width="1rem" height="1rem" />,
    text: 'საჩუქარი',
    background: 'linear-gradient(to right top, #162131, #162139)',
  },
  last: {
    icon: <Megaphone color="white" size="0.8rem" />,
    text: 'ბოლო ერთეული',
    background: 'linear-gradient(84.78deg, #FF7E00 0%, #FF2000 100%)',
  },
  best: {
    icon: <BestPrice width="0.9rem" height="0.9rem" />,
    text: 'საუკეთესო ფასი',
    background: 'linear-gradient(to right top, #ffc94b, #ff7f17)',
  },
}

const ProductTag = ({ iconType, className = '', type }) => {
  const [expandedWidth, setExpandedWidth] = useState('')
  const [isReady, setIsReady] = useState(false)
  const textRef = useRef(null)
  const buttonRef = useRef(null)

  const currentTag = tagConfig[iconType]

  useLayoutEffect(() => {
    if (textRef.current && currentTag) {
      textRef.current.style.opacity = '1'
      textRef.current.style.visibility = 'visible'
      textRef.current.style.position = 'absolute'
      textRef.current.style.whiteSpace = 'nowrap'

      const textContentWidth = textRef.current.scrollWidth
      const padding = type === 'details' ? 45 : 40
      const totalCalculatedWidth = textContentWidth + padding

      textRef.current.style.opacity = ''
      textRef.current.style.visibility = ''
      textRef.current.style.position = ''
      textRef.current.style.whiteSpace = ''

      setExpandedWidth(`${totalCalculatedWidth}px`)
      setIsReady(true)
    }
  }, [currentTag, type])

  useEffect(() => {
    const calculateWidth = () => {
      if (textRef.current && currentTag) {
        const tempSpan = document.createElement('span')
        tempSpan.style.font = window.getComputedStyle(textRef.current).font
        tempSpan.style.visibility = 'hidden'
        tempSpan.style.position = 'absolute'
        tempSpan.style.whiteSpace = 'nowrap'
        tempSpan.textContent = currentTag.text

        document.body.appendChild(tempSpan)
        const width = tempSpan.getBoundingClientRect().width
        document.body.removeChild(tempSpan)

        const padding = type === 'details' ? 45 : 40
        setExpandedWidth(`${width + padding}px`)
        setIsReady(true)
      }
    }

    calculateWidth()

    window.addEventListener('resize', calculateWidth)
    return () => window.removeEventListener('resize', calculateWidth)
  }, [currentTag, type])

  if (!currentTag) {
    return null
  }

  const getSizeClasses = () => {
    if (type === 'card') {
      return 'w-6 h-6 md:h-8 md:w-8'
    } else if (type === 'details') {
      return 'w-9 h-9'
    } else {
      return 'w-6 h-6 md:h-9 md:w-9'
    }
  }

  const getIconContainerClasses = () => {
    if (type === 'card') {
      return 'ml-[5px] md:ml-[6px] w-[14px] h-[14px] md:w-5 md:h-5'
    } else if (type === 'details') {
      return 'ml-[8px] w-5 h-5'
    } else {
      return 'ml-[5px] md:ml-[6px] w-5 h-5'
    }
  }

  return (
    <button
      ref={buttonRef}
      onClick={e => e.preventDefault()}
      className={`group ${getSizeClasses()} rounded-full flex items-center z-10 justify-start text-white text-sm shadow-lg overflow-hidden transition-[width] duration-500 ease-in-out ${
        isReady ? 'hover:w-[var(--expanded-width)]' : ''
      } ${className}`}
      style={{
        '--expanded-width': expandedWidth,
        background: currentTag.background,
      }}
      onMouseEnter={e => {
        if (expandedWidth && e.currentTarget) {
          e.currentTarget.style.setProperty('--expanded-width', expandedWidth)
        }
      }}
    >
      <div
        className={`mb-[2px] ${getIconContainerClasses()} flex items-center justify-center flex-shrink-0`}
      >
        {currentTag.icon}
      </div>
      <span
        ref={textRef}
        className="pl-1 font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-400 ease-in-out text-[13px] md:pr-3"
      >
        {currentTag.text}
      </span>
    </button>
  )
}

export default ProductTag
